import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { EditorModule } from 'primeng/editor';
import { ActivatedRoute, Router } from '@angular/router';
import { UserService } from '../../layout/service/user.service';
import { MessageService } from 'primeng/api';
import { ToastModule } from 'primeng/toast';

@Component({
    selector: 'app-notes-update',
    standalone: true,
    imports: [CommonModule, FormsModule, ButtonModule, InputTextModule, EditorModule, ToastModule],
    template: `
        <div class="p-6">
            <h1 class="text-3xl font-bold mb-6">Update Note</h1>
            <div class="space-y-4" *ngIf="note">
                <div>
                    <label class="block text-sm font-medium mb-2">Note</label>
                    <p-editor [(ngModel)]="note.note" [style]="{'height':'320px'}"></p-editor>
                </div>
                <div class="flex gap-4">
                    <button pButton label="Update" (click)="updateNote()"></button>
                    <button pButton label="Cancel" class="p-button-secondary" (click)="cancel()"></button>
                </div>
            </div>
        </div>
        <p-toast></p-toast>
    `,
    providers: [MessageService]
})
export class NotesUpdate implements OnInit {
    note: any = { USER_ID: '', note: '' };
    noteId: string = '';

    constructor(
        private userService: UserService,
        private router: Router,
        private route: ActivatedRoute,
        private messageService: MessageService
    ) {}

    ngOnInit() {
        this.noteId = this.route.snapshot.paramMap.get('id') || '';
        this.loadNote();
    }

    loadNote() {
        const userStr = localStorage.getItem('user');
        let userId = '1';
        if (userStr) {
            const user = JSON.parse(userStr);
            userId = user.ID_USER || '1';
        }
        this.userService.getNotes(userId).then(data => {
            // Assuming API returns an object with 'notes' or 'data' key, or directly an array
            const notesArray = data.notes || data.data || (Array.isArray(data) ? data : []);
            this.note = notesArray.find((n: any) => n.id == this.noteId);
            if (this.note) {
                this.note.USER_ID = userId; // Ensure USER_ID is set
            }
        }).catch(err => {
            this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to load note' });
        });
    }

    updateNote() {
        this.userService.updateNotes({ ...this.note, id: this.noteId }).then(() => {
            this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Note updated' });
            this.router.navigate(['/app/notes']);
        }).catch(err => {
            this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to update note' });
        });
    }

    cancel() {
        this.router.navigate(['/app/notes']);
    }
}